export default {
  brand: "AllChinaBuy Spreadsheet",
  brandShort: "Spreadsheet",
  language: "Language",
  nav: {
    spreadsheet: "Spreadsheet",
    categories: "Categories",
    reviews: "Reviews",
    shipping: "Shipping",
    qc: "QC",
    safety: "Safety",
    guides: "Guides",
    home: "Home",
    shoppingGuide: "Shopping Guide",
    mobileCategories: "Browse Categories",
  },
  cta: {
    explore: "Explore AllChinaBuy Spreadsheet",
    visitMain: "Visit Main Website",
    buyNow: "Buy It Now",
    viewAll: "View All Categories",
    readGuide: "Read Guide",
    readArticle: "Read the Full Guide",
    backHome: "Back to Home",
  },
  trust:
    "Independent informational resource • Updated regularly • English, French, Danish & German",
  categoryNames: {
    shoes: "Shoes",
    hoodies: "Hoodies/Sweaters",
    tshirts: "T-Shirts",
    jackets: "Jackets",
    pants: "Pants/Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "Underwear/Underpants",
    jersey: "Jersey",
    accessories: "Accessories",
    bags: "Bags",
    belts: "Belts",
    perfumes: "Perfumes",
    other: "Other Stuff",
  },
  footer: {
    disclaimer:
      "This is an independent informational resource and is not affiliated with, endorsed by, or sponsored by AllChinaBuy. Product links lead to our main website.",
    rights: "All rights reserved.",
    quickLinks: "Quick Links",
    categories: "Categories",
    resources: "Resources",
    about: "About This Site",
    aboutText:
      "A multilingual resource hub that helps you organize product finds, sellers and buying references for AllChinaBuy.",
  },
};